var _a, _b;
import * as t from "io-ts";
import { AiringType, Channel, } from "core/codegen/types";
export var PageType;
(function (PageType) {
    PageType["Article"] = "Article";
    PageType["BasicPage"] = "BasicPage";
    PageType["Contest"] = "Contest";
    PageType["HomePage"] = "HomePage";
    PageType["Interactive"] = "Interactive";
    PageType["Participate"] = "Participate";
    PageType["Program"] = "Program";
    PageType["ProgramOverview"] = "ProgramOverview";
    PageType["Video"] = "Video";
    PageType["TicketOverview"] = "TicketOverview";
})(PageType || (PageType = {}));
export var CardType;
(function (CardType) {
    CardType["Article"] = "Article";
    CardType["BasicPage"] = "BasicPage";
    CardType["Contest"] = "Contest";
    CardType["Interactive"] = "Interactive";
    CardType["Participate"] = "Participate";
    CardType["Person"] = "Person";
    CardType["Program"] = "Program";
    CardType["Video"] = "Video";
    CardType["VtmGoEpisode"] = "VtmGoEpisode";
    CardType["Ticket"] = "Ticket";
})(CardType || (CardType = {}));
export var BoxCoverType;
(function (BoxCoverType) {
    BoxCoverType["Program"] = "Program";
})(BoxCoverType || (BoxCoverType = {}));
export var CommonPageType;
(function (CommonPageType) {
    CommonPageType["Article"] = "Article";
    CommonPageType["BasicPage"] = "BasicPage";
    CommonPageType["Contest"] = "Contest";
    CommonPageType["Interactive"] = "Interactive";
    CommonPageType["Participate"] = "Participate";
    CommonPageType["Video"] = "Video";
})(CommonPageType || (CommonPageType = {}));
export var PageSubType;
(function (PageSubType) {
    PageSubType["Game"] = "game";
    PageSubType["SecondScreen"] = "second screen";
    PageSubType["Voting"] = "voting";
    PageSubType["Ticket"] = "ticket";
    PageSubType["Other"] = "other";
})(PageSubType || (PageSubType = {}));
export var CommerceProductIO = t.intersection([
    t.interface({
        name: t.string,
        category: t.string,
    }),
    t.partial({
        id: t.string,
        position: t.number,
        variant: t.string,
    }),
]);
export var TrackingDataIO = t.interface({
    list: t.string,
    product: CommerceProductIO,
});
export var UrlsIO = t.interface({
    __typename: t.literal("Urls"),
    webp: t.string,
    jpeg: t.string,
});
export var ImageIO = t.interface({
    __typename: t.literal("Image"),
    id: t.number,
    urls: UrlsIO,
    x: t.number,
    y: t.number,
});
export var ImageSMIO = t.interface({
    __typename: t.literal("ImageSM"),
    id: t.number,
    small: UrlsIO,
    medium: UrlsIO,
    x: t.number,
    y: t.number,
});
export var ImageSMLIO = t.interface({
    __typename: t.literal("ImageSML"),
    id: t.number,
    small: UrlsIO,
    medium: UrlsIO,
    large: UrlsIO,
    x: t.number,
    y: t.number,
});
export var ChannelIO = t.keyof((_a = {},
    // using "keyof" for better performance instead of "union"
    _a[Channel.Vtm] = "VTM",
    _a[Channel.Vtm2] = "VTM2",
    _a[Channel.Vtm3] = "VTM3",
    _a[Channel.Vtm4] = "VTM4",
    _a[Channel.News] = "NEWS",
    _a[Channel.Vtmgoexclusives] = "Exclusives",
    _a));
export var AiringTypeIO = t.keyof((_b = {},
    _b[AiringType.OnAir] = "on_air",
    _b[AiringType.ComingSoon] = "coming_soon",
    _b[AiringType.Archived] = "archived",
    _b));
export var AiringIO = t.intersection([
    t.interface({
        __typename: t.literal("Airing"),
        type: AiringTypeIO,
    }),
    t.partial({
        info: t.string,
    }),
]);
export var BroadcastIO = t.interface({
    __typename: t.literal("Broadcast"),
    uuid: t.string,
    start: t.string,
    end: t.string,
    channel: ChannelIO,
});
export var TrackingObjectIO = {};
export var ProgramOverviewCategoryLabels;
(function (ProgramOverviewCategoryLabels) {
    ProgramOverviewCategoryLabels["NewsAndActua"] = "Nieuws & Actua";
    ProgramOverviewCategoryLabels["Sports"] = "Sport";
    ProgramOverviewCategoryLabels["ShowsAndGames"] = "Show & Spel";
    ProgramOverviewCategoryLabels["Reality"] = "Reality";
    ProgramOverviewCategoryLabels["Series"] = "Series";
    ProgramOverviewCategoryLabels["Movies"] = "Films";
    ProgramOverviewCategoryLabels["Youth"] = "Kids";
})(ProgramOverviewCategoryLabels || (ProgramOverviewCategoryLabels = {}));
